import { useState } from "react";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../firebase";
import { Link } from "react-router-dom";
import { sendPasswordReset } from "../api/auth";
import PasswordInput from "../components/PasswordInput";
import ForageLogo from "../components/ForageLogo";

export default function LoginPage(){

  const [email, setEmail]       = useState("");
  const [password, setPassword] = useState("");
  const [error, setError]       = useState("");
  const [loading, setLoading]   = useState(false);

  const [mode, setMode]             = useState("login"); // "login" | "reset"
  const [resetEmail, setResetEmail] = useState("");
  const [resetMsg, setResetMsg]     = useState("");
  const [resetError, setResetError] = useState("");
  const [resetLoading, setResetLoading] = useState(false);

  async function handleLogin(){
    setLoading(true);
    setError("");
    try{
      await signInWithEmailAndPassword(auth, email, password);
    } catch {
      setError("Invalid email or password");
    } finally {
      setLoading(false);
    }
  }

  function handleKeyDown(e){
    if(e.key === "Enter") handleLogin();
  }

  async function handleReset(){
    setResetError("");
    setResetMsg("");
    setResetLoading(true);
    try{
      await sendPasswordReset(resetEmail);
      setResetMsg("If an account exists for that email, a reset link has been sent.");
    } catch {
      setResetError("Could not send reset email. Check the address and try again.");
    } finally {
      setResetLoading(false);
    }
  }

  return(

    <div className="authLayout">

      {/* LEFT PANEL */}
      <div className="authBrand">
        <div className="authBrandLogo">
          <ForageLogo size={48} color="#c8dba8" />
        </div>
        <h1>Forage</h1>
        <p className="authBrandTagline">
          Your household's home for<br />
          meals, groceries, and pantry.
        </p>
        <ul className="authFeatureList">
          <li>Plan meals for the whole week</li>
          <li>Build and browse your recipe library</li>
          <li>Track your pantry and shop smarter</li>
        </ul>
      </div>

      {/* RIGHT PANEL */}
      <div className="authFormArea">

        <div className="authBox">

          {mode === "login" ? (
            <>
              <h2>Welcome back</h2>

              {error && <p className="error">{error}</p>}

              <div className="authField">
                <label htmlFor="login-email">Email</label>
                <input
                  id="login-email"
                  type="email"
                  autoComplete="email"
                  placeholder="you@example.com"
                  value={email}
                  onChange={e=>setEmail(e.target.value)}
                  onKeyDown={handleKeyDown}
                />
              </div>

              <div className="authField">
                <label htmlFor="login-password">Password</label>
                <PasswordInput
                  id="login-password"
                  placeholder="Your password"
                  value={password}
                  onChange={e=>setPassword(e.target.value)}
                  onKeyDown={handleKeyDown}
                />
              </div>

              <button onClick={handleLogin} disabled={loading}>
                {loading ? "Signing in…" : "Login"}
              </button>

              <button
                className="forgotPasswordBtn"
                onClick={()=>{ setMode("reset"); setResetEmail(email); }}
              >
                Forgot password?
              </button>

              <p className="authSwitch">
                Don't have an account?
                <Link to="/signup"> Create one</Link>
              </p>
            </>
          ) : (
            <>
              <h2>Reset Password</h2>

              <p className="textMuted" style={{marginBottom:12}}>
                Enter your email and we'll send you a reset link.
              </p>

              {resetMsg   && <p className="pwSuccess">{resetMsg}</p>}
              {resetError && <p className="error">{resetError}</p>}

              <div className="authField">
                <label htmlFor="reset-email">Email</label>
                <input
                  id="reset-email"
                  type="email"
                  autoComplete="email"
                  placeholder="you@example.com"
                  value={resetEmail}
                  onChange={e=>setResetEmail(e.target.value)}
                  onKeyDown={e=>{ if(e.key==="Enter") handleReset(); }}
                />
              </div>

              {!resetMsg && (
                <button onClick={handleReset} disabled={resetLoading}>
                  {resetLoading ? "Sending…" : "Send Reset Email"}
                </button>
              )}

              <button
                className="forgotPasswordBtn"
                onClick={()=>{ setMode("login"); setResetMsg(""); setResetError(""); }}
              >
                ← Back to login
              </button>
            </>
          )}

        </div>

      </div>

    </div>

  );

}
